module.exports = __webpack_public_path__ + "static/img/Receive3Warm.66aefe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Receive3Warm.png
// module id = pBuK
// module chunks = 0